import { UIComponentCSSStyleImpl, UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { Colors } from '../../../../../utils/resources/colors';
export interface FeaturedCategoryListCSSStyle extends UIComponentCSSStyle
{
    getTitleCSSStyle(): object;
    getMobileTitleCSSStyle(): object;
    getPaginationCSSStyle(): object;
    getShowMoreCSSStyle(): object;
    getMobileShowMoreCSSStyle(): object;
}

export class FeaturedCategoryListCSSStyleImpl extends UIComponentCSSStyleImpl implements FeaturedCategoryListCSSStyle
{
    getMobileTitleCSSStyle(): object {
        return {
            display: "flex",
            textAlign: "center",
            justifyContent: 'flex-start',
            // height: "20px",
            fontWeight: 800,
            letterSpacing: 0,
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            // fontSize: "18px",
            color: this.getResources().getColor(Colors.color_6),
            fontFamily: this.getResources().getFontFamily(),
            // lineHeight: "20px",
            // marginTop: '20px',  
            // marginBottom: '8px',
            // marginLeft: '0px',
        };
    }
    getMobileShowMoreCSSStyle(): object {
        return {
            display: "flex",
            textAlign: "right",
            justifyContent: 'flex-end',
            // height: "15px",
            cursor: "pointer",
            fontWeight: "bold",
            letterSpacing: 0,
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            // fontSize: "12px",
            color: this.getResources().getColor(Colors.color_2),
            fontFamily: this.getResources().getFontFamily(),
            // lineHeight: "15px",
            // marginTop: '20px',  
            // marginBottom: '8px',
            // marginLeft: '0px',
        };
    }
    getTitleCSSStyle(): object 
    {
        return {
            display: "flex",
            textAlign: "center",
            justifyContent: 'flex-start',
            // height: "30px",
            fontWeight: 800,
            letterSpacing: 0,
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            // fontSize: this.getResources().getFont(Fonts.h11),
            color: this.getResources().getColor(Colors.color_6),
            fontFamily: this.getResources().getFontFamily(),
            // lineHeight: "30px",
            // marginTop: '52px',  
            // marginBottom: '38px',
            // marginLeft: '0px',
        };
    } 

    getShowMoreCSSStyle(): object 
    {
        return {
            display: "flex",
            textAlign: "right",
            justifyContent: 'flex-end',
            // height: "30px",
            cursor: "pointer",
            fontWeight: "bold",
            letterSpacing: 0,
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            // fontSize: "16px",
            color: this.getResources().getColor(Colors.color_2),
            fontFamily: this.getResources().getFontFamily(),
            // lineHeight: "30px",
            // marginTop: '52px',  
            // marginBottom: '38px',
            // marginLeft: '0px',
        };
    } 

    getPaginationCSSStyle(): object 
    {
        return {
            height: "50px",
            width: "100%",
            marginTop: "50px"
        };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/list/featuredcategorylistcss.tsx